/**
 * @deprecated Use `Modal` from `components/ui/Modal` for new code. It provides
 * overlay click, escape-to-close, body scroll lock, and `role="dialog"` semantics.
 * Migrate existing usages in a follow-up PR.
 */
import { PropsWithChildren } from 'react';
interface Props extends PropsWithChildren {
  zIndex?: string;
  styles?: string;
  className?: string;
}

const ModalOverlay = ({
  children,
  zIndex = 'z-40',
  styles = 'w-full h-full bg-gray-600/70 dark:bg-secondary-dark-800/70',
  className
}: Props) => {
  return (
    <div className={className || `fixed inset-0 ${styles} ${zIndex}`}>
      {children}
    </div>
  );
};

export default ModalOverlay;
